import React from 'react';
import { Link } from 'react-router-dom';
import { serviceDetails } from '../data/serviceDetails';
import { ROUTES, getServiceDetailRoute } from '../constants/routes';

/** Social profiles from legacy tendotec.at (published bundle); opens in new tab. */
const socialLinks = [
  { icon: 'instagram', href: 'https://www.instagram.com/tendotec.wien/', label: 'TendoTec auf Instagram' },
  { icon: 'facebook', href: 'https://www.facebook.com/Tendotec.wien', label: 'TendoTec auf Facebook' },
  { icon: 'tiktok', href: 'https://www.tiktok.com/@tendotec1', label: 'TendoTec auf TikTok' },
  {
    icon: 'google',
    href: 'https://www.google.com/maps/search/?api=1&query=TendoTec+Favoritenstraße+61%2F1+1100+Wien',
    label: 'TendoTec auf Google Maps',
  },
] as const;

const Footer: React.FC = () => {
  const services = Object.values(serviceDetails);

  return (
    <footer style={{ background: '#0f172a', color: 'white', padding: '6rem 0 2rem 0', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <div className="container">
        <div className="grid grid-cols-4" style={{ gap: '4rem', marginBottom: '4rem' }}>
          
          {/* Brand & Mission */}
          <div className="flex-col gap-6">
            <Link to={ROUTES.HOME} className="flex items-center gap-2">
              <div style={{ width: '40px', height: '40px', background: 'white', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0f172a' }}>
                <i className="fa-solid fa-microchip" style={{ fontSize: '1.2rem' }}></i>
              </div>
              <span style={{ fontSize: '1.4rem', fontWeight: 800, color: 'white' }}>Tendo<span style={{ color: '#3b82f6' }}>Tec</span></span>
            </Link>
            <p style={{ color: '#94a3b8', fontSize: '0.95rem', lineHeight: '1.7' }}>
              Wiens führende Experten für fortschrittliches Micro-Soldering und High-End Gerätereparaturen. Wir retten Technik, wo andere aufgeben.
            </p>
            <div className="flex gap-4" style={{ flexWrap: 'wrap' }}>
              {socialLinks.map((social) => (
                <a
                  key={social.icon}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.05)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    transition: 'all 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#3b82f6';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                  }}
                >
                  <i className={`fa-brands fa-${social.icon}`} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* All Services */}
          <div className="flex-col gap-4">
            <h4 style={{ color: 'white', fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem' }}>Dienstleistungen</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem' }}>
              {services.map(srv => (
                <Link key={srv.id} to={getServiceDetailRoute(srv.id)} style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.95rem', transition: 'color 0.2s' }} onMouseEnter={e => e.currentTarget.style.color = 'white'} onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}>
                  {srv.title}
                </Link>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="flex-col gap-4">
            <h4 style={{ color: 'white', fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem' }}>Schnellzugriff</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.75rem' }}>
              {[
                { name: 'Startseite', path: ROUTES.HOME },
                { name: 'Reparatur starten', path: ROUTES.SERVICES },
                { name: 'Über TendoTec', path: ROUTES.ABOUT },
                { name: 'Kontakt & Standort', path: ROUTES.CONTACT }
              ].map(link => (
                <Link key={link.name} to={link.path} style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '0.95rem', transition: 'color 0.2s' }} onMouseEnter={e => e.currentTarget.style.color = 'white'} onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}>
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact & Map Info */}
          <div className="flex-col gap-4">
            <h4 style={{ color: 'white', fontSize: '1.1rem', fontWeight: 700, marginBottom: '0.5rem' }}>Standort Wien</h4>
            <div className="flex-col gap-5">
              <div className="flex gap-4">
                <div style={{ color: '#3b82f6', fontSize: '1.2rem' }}><i className="fa-solid fa-location-dot"></i></div>
                <p style={{ color: '#94a3b8', fontSize: '0.9rem', margin: 0 }}>Favoritenstraße 61/1, <br/> 1100 Wien</p>
              </div>
              <div className="flex gap-4">
                <div style={{ color: '#3b82f6', fontSize: '1.2rem' }}><i className="fa-solid fa-clock"></i></div>
                <div style={{ color: '#94a3b8', fontSize: '0.9rem' }}>
                  Mo - Do: 10:00–19:00 <br/>
                  Fr: 10:00–13:00 / 15-19 <br/>
                  Sa: 12:00–18:00
                </div>
              </div>
              <div className="flex gap-4">
                <div style={{ color: '#3b82f6', fontSize: '1.2rem' }}><i className="fa-solid fa-phone"></i></div>
                <a href="tel:+436766999888" style={{ color: 'white', fontWeight: 700, textDecoration: 'none' }}>+43 676 6999 888</a>
              </div>
            </div>
          </div>

        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.05)', paddingTop: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="mobile-footer-bottom">
          <p style={{ color: '#64748b', fontSize: '0.85rem' }}>&copy; {new Date().getFullYear()} TendoTec Premium Repair. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6 items-center">
            <Link to={ROUTES.IMPRESSUM} style={{ color: '#64748b', fontSize: '0.85rem' }}>Impressum</Link>
            <Link to={ROUTES.DATENSCHUTZ} style={{ color: '#64748b', fontSize: '0.85rem' }}>Datenschutz</Link>
            <div style={{ background: 'rgba(255,255,255,0.03)', padding: '0.5rem 1rem', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <i className="fa-solid fa-leaf" style={{ color: '#22c55e' }}></i>
              <span style={{ fontSize: '0.75rem', fontWeight: 600, color: '#94a3b8' }}>Partner der Geräte-Retter-Prämie</span>
            </div>
          </div>
        </div>
      </div>
      
      <style>{`
        @media (max-width: 1024px) {
          footer .grid-cols-4 { grid-template-columns: 1fr 1fr; gap: 3rem; }
        }
        @media (max-width: 768px) {
          footer .grid-cols-4 { grid-template-columns: 1fr; gap: 3rem; }
          .mobile-footer-bottom { flex-direction: column; gap: 1.5rem; text-align: center; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
